module.exports = __webpack_public_path__ + "static/warehouse-05a6b2687845a175acb6c9355b92c3fb.png";